export default __webpack_public_path__ + "assets/images/95414f18e84f64e10cb0dee1c358c13d.svg";